// Rails :back link uses previous url, which does not save form states
var Reverb = window.Reverb || {};

Reverb.LinkToBack = (function () {
  var backLinkSelector = '[data-link-to-back]';

  function bindLinkClicks() {
    $(document).on('click', backLinkSelector, function (e) {
      e.preventDefault();
      history.back();
    });
  }

  return {
    bindLinkClicks: bindLinkClicks
  };
})();

$(Reverb.LinkToBack.bindLinkClicks);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/link_to_back.js